var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _ellipse, _circle2, _circle3, _circle4, _circle5, _path12, _path13, _path14, _polygon, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g, _path35, _path36, _path37, _path38, _circle6, _path39, _circle7, _circle8, _path40, _path41, _path42, _path43, _circle9, _ellipse2, _path44, _rect, _path45, _path46, _path47, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoubt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1473.68 1316.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1711.27,1323c-24.1-54.82-70.39-100.57-126-123.08-57.91-23.45-124.41-14.92-185.41-22.77-53-6.83-91.2-30.48-122.84-72.53-30.31-40.29-57.48-84.91-107-103.55-39.16-14.72-83.68-10.64-122.6,4.71C975.68,1034,921.51,1094.12,875.89,1154c-41.65,54.69-75.62,114.57-152.66,116.52s-150.48-42-228.09-30.36c-102.59,15.4-188,100.8-205.92,202.46-16.78,95.28,25.32,187.7,97.65,242H1630.09C1721.23,1588,1769.06,1454.39,1711.27,1323Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#f7f0e3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M587.42,1684.64h3.42a262.47,262.47,0,0,0,54.18-93c19.14-56.91,18.34-116.64-2.27-168.18-10.42-26-25.46-50.32-40-73.8-14.75-23.8-30-48.42-40.35-74.81a167.34,167.34,0,0,1-9.35-34.57c-.85-.11-1.71-.2-2.57-.3a169.14,169.14,0,0,0,9.59,35.79c10.43,26.59,25.75,51.31,40.56,75.21,14.48,23.39,29.46,47.57,39.8,73.41,20.39,51,21.18,110.11,2.22,166.46A259.55,259.55,0,0,1,587.42,1684.64Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1624.08,1576.21c25.62,5.46,50.31,10.36,74.18,13.44.41-.79.8-1.59,1.21-2.38-24.07-3.06-49-8-74.86-13.5-39.4-8.4-82-17.48-124.34-17.48-26.19,0-52.24,3.48-77.3,12.77a157.42,157.42,0,0,0-27.36,13.3c-22.63-9.65-45.38-20.18-67.91-31.74,16.35-12.31,32.87-24.38,49.58-36,124-86.57,238.39-135.65,348.93-149.58-.22-.81-.45-1.62-.68-2.43-110.84,14-225.51,63.25-349.69,150-17,11.91-33.92,24.24-50.61,36.82a837.9,837.9,0,0,1-74.62-43.36c-43.95-28.8-96.24-69.91-141.9-124.53,177-19.86,357.1-44.87,504.22-143.19,5.58-3.74,11.77-8.14,18.18-13.13-.71-.51-1.42-1-2.14-1.5-6.14,4.76-12.07,9-17.43,12.55-147.08,98.3-327.57,123.12-504.75,143-32.26-39-61.09-84.88-81.13-138-31.2-82.67-29.56-163.79,4.53-222.57,1.48-2.56,3-5.07,4.65-7.56-1.42.66-2.83,1.34-4.24,2q-1.32,2.13-2.58,4.29c-34.46,59.44-36.17,141.34-4.69,224.72,19.92,52.78,48.49,98.44,80.5,137.38q-15.39,1.73-30.74,3.41c-36.9,4.08-75,8.29-112.1,13-13.52,1.75-27.27,3.78-41,6.32-29.34-61.91-61.56-122.3-103.21-174.1-.59.6-1.2,1.17-1.8,1.76,41.29,51.4,73.31,111.35,102.47,172.82-59.69,11.38-117.64,32.78-148.58,82.58-28.9,46.51-28.87,110.8.08,191.08,1,2.78,2,5.52,3.08,8.24h2.67c-1.14-3-2.28-6-3.4-9.09-28.68-79.52-28.78-143.08-.31-188.91,30.58-49.21,88.21-70.32,147.56-81.57C929,1427,939,1449.06,948.9,1471l1.08,2.39c34.53,76.22,70.24,149.77,117,211.24h3.12c-47.19-61.58-83.1-135.58-117.84-212.27l-1.08-2.39c-9.86-21.76-19.78-43.66-30-65.38,13.42-2.48,26.91-4.47,40.17-6.17,37-4.77,75.16-9,112-13q16.16-1.79,32.37-3.59c46.1,55.48,99,97.16,143.51,126.29a840,840,0,0,0,73.78,43c-42.53,32.16-83.9,66-124.28,99q-21,17.16-42.39,34.56h4q20.18-16.38,40-32.63c40.67-33.27,82.33-67.36,125.16-99.71,22.41,11.53,45,22,67.54,31.67-30.79,19.58-55.89,49.9-71.06,86.73-1.9,4.61-3.56,9.26-5.09,13.94h2.63c1.45-4.36,3-8.69,4.77-13,15.22-36.92,40.52-67.22,71.55-86.49,62.92,26.73,124.75,46.57,177.89,62.29l2,.59c22.39,6.62,45.29,13.41,65.54,24.31.57-.65,1.14-1.29,1.7-1.94-20.58-11.17-43.82-18.05-66.54-24.76l-2-.59c-52.59-15.57-113.71-35.16-176-61.5a155.65,155.65,0,0,1,25.39-12.16C1488.7,1547.37,1560.63,1562.69,1624.08,1576.21Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M393.14,1414.27c11,45.2,6.11,94-13.52,133.93-12.86,26.14-31.43,49.81-54.3,70.13.45.71.92,1.41,1.38,2.11,23.24-20.59,42.11-44.6,55.16-71.14,19.89-40.43,24.89-89.86,13.71-135.62-8.74-35.75-26.3-66-50.56-87.94-.54.63-1.08,1.27-1.61,1.91C367.25,1349.23,384.53,1379.05,393.14,1414.27Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M959,841.72C980.74,864,990.5,901.46,978.49,936c-11.63,33.47-37.12,61.19-67.74,79-24.64,14.34-56.78,22.25-81,7.23-18.11-11.22-27.5-33.24-28-54.53s6.64-42.06,15.49-61.43c12.48-27.32,29.27-53.8,54.29-70.41C906,813,938,820.32,959,841.72Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#f7f0e3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M670.27,451.52H489.93V371H670.27Zm-176.59-3.75H666.52V374.7H493.68Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#e9ddca"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M553,528.56H372.61V448H553Zm-176.59-3.75H549.2V451.75H376.36Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#e9ddca"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1696.37,614.41q-17.52-58.24-61.62-107.07t-120.54-80.78q-76.35-31.92-194-31.92-93.86,0-191.31,25.32T959.59,492.3l62.28,171-33.38,27,48.41,14.23q71.67-37.51,130.6-54.48t125.09-16.88q66.2,0,100.24,31.92c22.69,21.34,34,47,34,77q0,54.48-34.91,96.73t-77.3,85.49q-29.39,30-57,61.94a444.74,444.74,0,0,0-48.74,68.61,372.8,372.8,0,0,0-34,78.88q-12.93,42.29-12.87,94.84c0,11.31.24,24.76.9,40.42.11,2.88.26,5.7.43,8.48h-45.76l49.94,33.77h242.81a162.28,162.28,0,0,1-1.85-26.29v-22.57a163.15,163.15,0,0,1,12.87-62.92,325.37,325.37,0,0,1,32.22-59.19,436.2,436.2,0,0,1,43.23-53.5q23.9-25.41,46-47.94,29.37-30,60.66-63.84a502.25,502.25,0,0,0,55.21-71.36,400.76,400.76,0,0,0,39.52-81.76q15.63-44.12,15.69-96.73T1696.37,614.41Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#e49b31"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.18,621.25q-65.51,0-123.62,16.34T988.49,690.31l-76.4-205.4q70.93-45.45,167.3-70t189.07-24.5q116.3,0,191.74,30.89t119.13,78.17q43.58,47.32,60.89,103.63t17.28,107.23q0,50.94-15.5,93.62a385.16,385.16,0,0,1-39.06,79.12,487.59,487.59,0,0,1-54.56,69.06q-30.9,32.75-60,61.78-21.84,21.84-45.45,46.4a425.16,425.16,0,0,0-42.73,51.78,313.46,313.46,0,0,0-31.84,57.28,155.07,155.07,0,0,0-12.72,60.9v21.83a152.18,152.18,0,0,0,1.84,25.45h-240a253.59,253.59,0,0,1-4.56-40.89c-.65-15.15-.89-28.17-.89-39.12q0-50.87,12.73-91.79a357,357,0,0,1,33.61-76.34A430.48,430.48,0,0,1,1206.62,963q27.26-30.9,56.34-60,41.8-41.8,76.4-82.73,34.44-40.92,34.5-93.62c0-29.12-11.19-53.91-33.61-74.57S1284.8,621.25,1241.18,621.25Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#fbc343"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1426.93,1547q0,65.67-42.51,101.39t-96.15,35.77q-53.73,0-96.19-35.77T1149.61,1547q0-65.58,42.47-101.38c43.63-36.82,108.17-45,159.26-19.19C1396.66,1449.37,1426.93,1495.93,1426.93,1547Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#e49b31"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.43,1547q0,65.67-42.51,101.39t-96.15,35.77q-53.73,0-96.19-35.77T1102.11,1547q0-65.58,42.47-101.38t96.19-35.77q53.65,0,96.15,35.77T1379.43,1547Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#fbc343"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 634.88,
    cy: 921.57,
    r: 26.15,
    transform: "translate(-668.13 1004.85) rotate(-79.38)",
    fill: "#d3dfff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 658.52,
    cy: 972.77,
    rx: 14.71,
    ry: 14.81,
    transform: "translate(-699.16 1069.9) rotate(-79.39)",
    fill: "#d3dfff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 570.35,
    cy: 789.9,
    r: 102.96,
    transform: "translate(-671.75 263.7) rotate(-45)",
    fill: "#d3dfff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.56,
    cy: 418.95,
    r: 12.97,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.09,
    cy: 418.95,
    r: 12.97,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.63,
    cy: 418.95,
    r: 12.97,
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M496.6,1632.62l9.62,37.09a21.24,21.24,0,0,0,22.2,15.5c31.55-2.14,97.08-9.87,134.7-37.59l-10.69-53.45c-51.72-2.93-100.09-.05-142,14C500,1611.75,493.91,1622.26,496.6,1632.62Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#102048"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M556.87,1662.14a1.26,1.26,0,0,1-1.2-.91L542.75,1615a1.25,1.25,0,0,1,.87-1.54,1.24,1.24,0,0,1,1.54.87l12.92,46.25a1.23,1.23,0,0,1-1.21,1.58Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M584.79,1655.89a1.24,1.24,0,0,1-1.2-.91l-12.92-46.25a1.25,1.25,0,0,1,2.41-.67L586,1654.31a1.26,1.26,0,0,1-.87,1.54A1.32,1.32,0,0,1,584.79,1655.89Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "336.95 1061.19 216.75 1096.86 306.02 1219.18 434.18 1229.37 610.95 1154.62 543.77 1053.55 336.95 1061.19",
    fill: "#fbc343"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M765.41,1449.13c264-78.14,306.4,155.16-105.48,197.63-14.55-16.37-31.55-44.78-38.3-68.52l217.51-100.51Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#fbc343"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M776.62,1616.34c-12.35-4-24.18-11.77-24.18-11.77L710,1617.88l9.72,46.15,44.07,9C777.24,1648.43,778,1628.26,776.62,1616.34Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#f9b384"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M622.58,1579.86l-1.89-3.24c45.38-26.37,161.6-89.73,260.63-108.41l.69,3.69C783.56,1490.47,667.78,1553.59,622.58,1579.86Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#e49b31"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M617.21,1432.14C371.5,1385.43,307.87,1621.56,719.74,1664a149.61,149.61,0,0,0,32.7-59.46c-63.26-42.33-134-82.57-211.53-120.9Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#fbc343"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M751.44,1606.15c-11.69-7.44-23.87-15.3-36.77-23.63-64.72-41.79-138.09-89.15-200.42-116.16l1.5-3.44c62.61,27.13,136.11,74.58,201,116.45,12.89,8.33,25.06,16.19,36.74,23.62Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#e49b31"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M436.94,1549.22l-3.28-1.81c9.22-16.7,24-28,43.9-33.47l1,3.61C459.39,1522.86,445.78,1533.22,436.94,1549.22Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#e49b31"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M949.77,1535c-8.84-16-22.46-26.36-41.63-31.68l1-3.61c19.91,5.52,34.68,16.78,43.9,33.48Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#e49b31"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M696.73,1662,694,1659.4c19.66-21.05,31.73-43.28,36.91-67.94l3.67.77C729.24,1617.58,716.87,1640.39,696.73,1662Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#e49b31"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M899.16,1602.59c-31.48-19.45-92.51,14.16-107.83,15.85-4.47.5-9.63-.48-14.71-2.1,1.4,11.92.62,32.09-12.81,56.64l7.49,1.52s51.75,19,106.65,7.93C928.62,1672.24,923.91,1617.88,899.16,1602.59Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#102048"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M856.25,1666.21a1.31,1.31,0,0,1-.38-.06,1.25,1.25,0,0,1-.81-1.57c3.74-11.84,5.37-35.14-5.46-50.79a1.25,1.25,0,1,1,2-1.42c11.35,16.38,9.68,40.65,5.79,53A1.26,1.26,0,0,1,856.25,1666.21Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M831.56,1670.89a1.19,1.19,0,0,1-.37-.06,1.24,1.24,0,0,1-.82-1.56c3.74-11.85,5.37-35.14-5.46-50.79a1.25,1.25,0,1,1,2.06-1.42c11.34,16.38,9.67,40.65,5.78,53A1.24,1.24,0,0,1,831.56,1670.89Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M573.74,1127.68s61.88-52.62,59.59-62.62c-1.63-7.15-19.16,3.33-19.16,3.33s24.58-29.16,23.33-32.71c-2.23-6.32-19.24,5.47-19.24,5.47s11.5-16.54,6-19.23-17.47,7.5-17.47,7.5,7-9.19,3.71-11.6-17.47,7.5-17.47,7.5,5.09-11.58-5.73-7.19-86.63,74-86.63,74Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#f9b384"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M599.06,1065.27a1.24,1.24,0,0,1-.84-.33c-10.62-9.7-15.31-12.06-27-15.67a1.25,1.25,0,1,1,.74-2.38c12.14,3.73,17,6.17,28,16.2a1.25,1.25,0,0,1-.85,2.18Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#e28b6d"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M580.42,1093.81h-.18a1.25,1.25,0,0,1-1.06-1.41c1.21-8.7,4-14.14,8.37-16.63,3.78-2.12,8.7-1.9,14.61.65a1.25,1.25,0,0,1-1,2.3c-5.16-2.23-9.33-2.49-12.39-.77-3.64,2-6,7-7.13,14.79A1.24,1.24,0,0,1,580.42,1093.81Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#e28b6d"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M577.5,1041.21a1.27,1.27,0,0,1-.91-.4,1.25,1.25,0,0,1,0-1.76l15.53-14.64a1.25,1.25,0,0,1,1.72,1.82l-15.53,14.63A1.24,1.24,0,0,1,577.5,1041.21Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#e28b6d"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M591.88,1046.21a1.26,1.26,0,0,1-.91-2.12l14.92-15.54a1.25,1.25,0,1,1,1.8,1.73l-14.91,15.54A1.25,1.25,0,0,1,591.88,1046.21Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#e28b6d"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M606.56,1055a1.28,1.28,0,0,1-.85-.34,1.26,1.26,0,0,1-.06-1.77l11.7-12.55a1.25,1.25,0,0,1,1.83,1.7l-11.7,12.56A1.27,1.27,0,0,1,606.56,1055Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#e28b6d"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M807.5,1479.64l-226.25,8.75-25-206.25s75.74-71.85,104.88-98.3l49.2-2.52C863,1250.69,838,1337.34,807.5,1479.64Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#3a6bea"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M710.33,1181.32S885,1196.25,940,1315.89c53.87,117.06-167.5,158.75-167.5,158.75Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#3a6bea"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M510.73,1207l72.16-87.81-67.48-40.89c-28.15,19.57-82.58,63.9-128.71,114.1-10.18,11.08-18.14,24-22.14,38.27a82.34,82.34,0,0,0-2.12,35.93h0c5,30.65,29.12,54.31,61.31,58.08,27.49,3.21,132.5-5,217.5-30l25-96.49C653.4,1190.86,557.93,1189.59,510.73,1207Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#3a6bea"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M856.05,1228.79l1.13-.26-2.37-1.38c-12.8,2.95-26,6-39,7.53-7.83.94-34,2.67-41.6-14.74-3.8-8.66-.92-18.3,3.38-25.06l-1.88-.54c-4.4,7.17-7.22,17.22-3.21,26.35,8.15,18.6,35.38,16.84,43.53,15.85C829.41,1234.93,843,1231.81,856.05,1228.79Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.55,1363.72c-8.34-3.22-17-6.55-26-5.7-15.9,1.51-29.5,17.22-30.32,35-.56,12.14,4.08,24.87,12.92,36.07l1.6-1c-8.65-10.88-13.19-23.24-12.65-35,.79-16.92,13.63-31.83,28.62-33.25,8.62-.8,16.66,2.29,25.17,5.58,3,1.18,6.13,2.36,9.27,3.37.16-.61.32-1.21.46-1.82C943.54,1366,940.52,1364.87,937.55,1363.72Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.8,1304.09c-10.9-9-27.84-11.42-46.47-6.61-16.6,4.3-30.84,12.8-40.62,24.06.64.2,1.27.44,1.92.63,9.52-10.68,23.23-18.75,39.17-22.87,18-4.67,34.37-2.39,44.81,6.24a40.66,40.66,0,0,1,11,15.17l1.94-.22A43,43,0,0,0,496.8,1304.09Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.24,1180.08c20.43-5.07,40.37-12.2,58.75-22.79,6.95-4,14.79-9.1,20.31-16.59,5.87-8,7.82-17.47,5.22-25.39a19.89,19.89,0,0,0-5.09-8l-1.44,1.18a18,18,0,0,1,4.74,7.43c2.42,7.34.57,16.2-4.94,23.68-5.31,7.21-13,12.18-19.73,16.08-17.35,10-36.1,16.9-55.37,21.89Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#fff"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M726.31,1135.46l0,3.2-.51,49.73-.06,5.39a31,31,0,0,1-61.94,0l-.6-61.46Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#f9b384"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M726.28,1138.66l-.51,49.73c-27.64-11.25-39-41.17-39-41.17Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#102048"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M737.21,1051.88c9.91,11.89,38.83,79.24,9.51,102.22-33,25.86-83.2-16.64-83.2-16.64L656.79,1059l43.58-11.49Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#f9b384"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M634.58,1047.56s-96.66,50.42-17.84,195.75c10.12,18.66,32.54,26.81,51.72,17.7h0a39.21,39.21,0,0,0,17.2-54.76c-12.89-22.9-25.34-52.39-20-74.34Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#102048"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 643.71,
    cy: 1071.43,
    r: 26.15,
    transform: "translate(-849.33 398.03) rotate(-45)",
    fill: "#fbc343"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M675.88,1102.84c-2.83-16.31-4.55-27.5,11.94-35.91,0,0,58.11,10.57,69.2-11.35s-5.81-56.53-41.2-32.49c-90.6-17.7-102.75,67.09-75.28,95.35l27.11-4.16A9.88,9.88,0,0,0,675.88,1102.84Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#102048"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 440.61,
    cy: 731.94,
    r: 3.86,
    fill: "#102048"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 466.76,
    cy: 719.06,
    r: 3.86,
    fill: "#102048"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M744.34,1114.78a1.08,1.08,0,0,1-.75-.3,1.1,1.1,0,0,1,0-1.55c1.55-1.63,3.25-3.92,2.54-5.58s-3.88-2.47-5.31-2.47c-3.08,0-4.56-5.49-4.83-6.59a1.1,1.1,0,1,1,2.13-.51c.56,2.32,1.83,4.91,2.7,4.91,1.47,0,6,.69,7.31,3.79.95,2.22,0,4.89-3,8A1.1,1.1,0,0,1,744.34,1114.78Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#102048"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M744.54,1129.44a1.07,1.07,0,0,1-.61-.19c-7.27-4.91-14.62-.79-14.69-.75a1.09,1.09,0,0,1-1.49-.4,1.11,1.11,0,0,1,.4-1.5c.35-.2,8.61-4.83,17,.84a1.09,1.09,0,0,1,.3,1.52A1.1,1.1,0,0,1,744.54,1129.44Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#102048"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M719.18,1086.16c2.2,4.13-1.63,5-6.12,7.35s-9.08,3.26-10.13,1.28,1.74-5.5,6.23-7.89S717.48,1083,719.18,1086.16Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#102048"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M735.54,1078.69c1,3.69,3.72,2.08,7.73,1s7.24-3.06,6.77-4.82-4.08-2.34-8.08-1.29S734.79,1075.84,735.54,1078.69Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#102048"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 703.04,
    cy: 1120.92,
    r: 11.39,
    transform: "translate(-853.97 402.64) rotate(-42.69)",
    fill: "#eb5d60",
    opacity: 0.4
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 659.78,
    cy: 1120.96,
    rx: 15.43,
    ry: 17.53,
    transform: "translate(-911 587.5) rotate(-52.34)",
    fill: "#f9b384"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M666.56,1126.67a1.09,1.09,0,0,1-1.09-1.09,9.59,9.59,0,0,0-4.21-8,7.73,7.73,0,0,0-7.19-.95,1.1,1.1,0,0,1-.83-2,9.92,9.92,0,0,1,9.24,1.17,11.77,11.77,0,0,1,5.18,9.8A1.09,1.09,0,0,1,666.56,1126.67Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#102048"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 461.92,
    y: 1227.05,
    width: 58.14,
    height: 2.5,
    transform: "translate(-1024.51 384.07) rotate(-47.25)",
    fill: "#102048"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M787.86,1389.59l-.72-2.39c28.73-8.76,56.61-19.24,81.88-50.84l2,1.56C845.26,1370.08,817,1380.71,787.86,1389.59Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#102048"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M805.33,1292.78H560.92c-8.79,0-15.92,7.7-15.92,17.21V1484.5c0,9.51,7.13,17.22,15.92,17.22H805.33c8.79,0,15.92-7.71,15.92-17.22V1310C821.25,1300.48,814.12,1292.78,805.33,1292.78Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#d3dfff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M696,1386.22a1.75,1.75,0,0,1,1.68,1.82v18.42a1.76,1.76,0,0,1-1.68,1.82H670.22a1.76,1.76,0,0,1-1.68-1.82V1388a1.75,1.75,0,0,1,1.68-1.82H696m0-5H670.22a6.76,6.76,0,0,0-6.68,6.82v18.42a6.76,6.76,0,0,0,6.68,6.82H696a6.76,6.76,0,0,0,6.68-6.82V1388a6.76,6.76,0,0,0-6.68-6.82Z",
    transform: "translate(-280.26 -370.95)",
    fill: "#1f3c88"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 1311.18,
    width: 1473.68,
    height: 5,
    fill: "#102048"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubt);
export default __webpack_public_path__ + "static/media/Doubt.bb8d59074e5ec4c01c88e3594ab40974.svg";
export { ForwardRef as ReactComponent };